/* eslint-disable react/no-unknown-property */
/* eslint-disable react/self-closing-comp */
/* eslint-disable react/no-unescaped-entities */
import { Box } from "@mui/system";
import MDBox from "~/components/MDBox";
import PublicFooter from "~/pages/public/PublicFooter";

const TermsConditions = () => {
  return (
    <MDBox m={4}>
      <Box className="static-pages">
        <div className="content-wrapper">
          <header>
            <nav className="navbar navbar-expand-lg navbar-light primary-nav container justify-content-start align-items-center">
              {/* <a href="https://www.teamcomputers.com" target="_blank" className="navbar-brand inner"><img
            src="../assets/images/tcpl-logo.png" alt="tcpl-logo"></a>
        <a href="/" className="brand-logo diims-logo inner"><img src="../assets/images/diims-logo-white.png"
            alt="diims-logo"></a> */}
            </nav>
          </header>
          <div classNameName="content mt-5 pt-5 pb-5 container">
            <h2 className="text-center">Terms & Conditions</h2>

            <p>
              <strong>Notice:</strong>
            </p>
            <p>
              PLEASE READ THESE TERMS &amp; CONDITIONS CAREFULLY. BY ACCESSING
              THE PlantWatch APP (“PlantWatch APP”)/PlantWatch WEBSITE
              (collectively “PlantWatch Platform”) YOU AGREE TO BE BOUND BY THE
              TERMS &amp; CONDITIONS STATED BELOW. IF YOU DO NOT AGREE TO THE
              TERMS &amp; CONDITIONS STATED BELOW, PLEASE DO NOT ACCESS THE
              PlantWatch PLATFORM. TEAM COMPUTERS PRIVATE LIMITED (“TCPL”)
              RESERVES THE RIGHT TO CHANGE, MODIFY OR AMEND THESE TERMS AND
              CONDITIONS WITHOUT ANY NOTICE.
            </p>
            <p>
              <strong>Limitation Of Liability:</strong>
            </p>
            <p>
              IN NO EVENT SHALL TCPL, THEIR OFFICERS, DIRECTORS, EMPLOYEES, OR
              AGENTS OR ITS LICENSORS, SUPPLIERS, OR VENDORS, BE LIABLE FOR ANY
              DIRECT, INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES OF
              ANY KIND, OR FOR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF
              USE, DATA OR PROFITS, WHETHER OR NOT TCPL HAS BEEN ADVISED OF
              POSSIBILITY OF THE DAMAGE, ARISING OUT OF OR IN CONNECTION WITH
              THE USE OR PERFORMANCE OF THE PlantWatch PLATFORM, INCLUDING
              WITHOUT LIMITATION, DAMAGES ARISING FROM MISTAKE, OMISSION, VIRUS,
              DELAY, OR INTERRUPTION OF SERVICE. IN NO EVENT SHALL TCPL BE
              LIABLE OR RESPONSIBLE FOR ANY DAMAGES OR CONSEQUENCES ARISING FROM
              OR RELATED TO YOUR INAPPROPRIATE OR UNAUTHORIZED USE OF THE
              PlantWatch PLATFORM OR ITS CONTENT.
            </p>
            <p>
              YOU SPECIFICALLY ACKNOWLEDGE THAT TCPL SHALL NOT BE LIABLE FOR
              USER SUBMISSIONS OR THE DEFAMATORY, OFFENSIVE, OR ILLEGAL CONDUCT
              OF ANY THIRD PARTY AND THAT THE RISK OF HARM OR DAMAGE FROM THE
              FOREGOING RESTS ENTIRELY WITH YOU.
            </p>
            <p>
              <strong>LINKS:</strong>
            </p>
            <p>
              The PlantWatch Platform may contain links to third party websites
              that are not owned or controlled by TCPL. TCPL is not affiliated
              with those websites, has no control over, and assumes no
              responsibility for, the content, privacy policies, or practices of
              any third party websites. In addition, TCPL will not and cannot
              censor or edit the content of any third-party site. By using the
              PlantWatch Platform, you expressly release TCPL from any and all
              liability arising from your use of any third-party website.
              Accordingly, we encourage you to be aware when you have left the
              PlantWatch Platform and to read the terms and conditions and
              privacy policy of each other website that you visit.
            </p>

            <p>
              <strong>YOUR OBLIGATIONS WHEN USING THIS WEBSITE </strong>
            </p>
            <p>
              TCPL hereby grants you a limited license to copy and use the
              materials, features, and services provided by the PlantWatch
              Platform (collectively the "Materials") solely for your personal,
              non-commercial use, subject to these Terms. The design and layout
              of the PlantWatch Platform are specifically excluded from the
              Materials. No copying, reproducing or other use of the PlantWatch
              Platform or Materials is authorized and you are strictly bound by
              the Copyright LaPlantWatch. Framing of the PlantWatch Platform or
              Materials or posting of Materials on other website is strictly
              prohibited.
            </p>
            <p>
              The products, technology, or processes described or used on the
              PlantWatch Platform may be the subject of intellectual property
              rights reserved by TCPL. Except for the limited license granted
              above, nothing contained herein confers to you in any manner,
              whether by implication, estoppel or otherwise, any license, title,
              or ownership of or to any intellectual property right of TCPL or
              any third party.
            </p>

            <p>
              <strong></strong>
              <strong>OUR LIABILITY TO YOU </strong>
            </p>
            <p>
              We provide the content on PlantWatch Platform in good faith but
              give no warranty or representation that the content is accurate,
              complete or up-to-date, nor that the PlantWatch Platform does not
              infringe the rights of any third party. Except as permitted under
              the Product Terms, we accept no responsibility or liability for
              your use of content on PlantWatch Platform and such use is
              entirely at your own risk. While we take reasonable precautions to
              prevent the existence of computer viruses and/or other malicious
              programs on the PlantWatch Platform, we cannot accept any
              liability for them.
            </p>
            <p>
              Information transmitted via PlantWatch Platform will pass over
              public telecommunications networks. We make no representation or
              warranty that the operation of the PlantWatch Platform will be
              uninterrupted or error free and disclaim all liability in respect
              thereof. The PlantWatch Platform may contain links to other
              websites. We accept no responsibility or liability for any
              material supplied by or contained on any third party website which
              is linked from or to PlantWatch Platform, or any use of personal
              data by such third party.
            </p>
            <p>
              <strong>YOUR MEMBERSHIP ACCOUNT</strong>
            </p>

            <p>
              In order to access some features of the PlantWatch Platform, you
              will have to create an account. You may never use another's
              account without permission. When creating your account, you must
              provide accurate and complete information. You are solely
              responsible for the activity that occurs on your account, and you
              must keep your account password secure. You must notify TCPL
              immediately of any breach of security or unauthorized use of your
              account. You will be liable for any use made of your account or
              password and the losses of TCPL or others due to such unauthorized
              use. TCPL will not be liable for your losses caused by any
              unauthorized use of your account.
            </p>
            <p>
              TCPL has the right to refuse service, terminate accounts,
              terminate your access to PlantWatch Platform, remove or edit
              content, or cancel orders in its sole discretion, immediately and
              with or without cause.
            </p>
            <p>
              <strong>ELECTRONIC COMMUNICATIONS </strong>
            </p>

            <p>
              When you visit PlantWatch Platform or send e-mails to us, you are
              communicating with us electronically. You consent to receive
              communications from us electronically. We will communicate with
              you by e-mail or by posting notices on the PlantWatch Platform.
              You agree that all agreements, notices, disclosures and other
              communications that we provide to you electronically satisfy any
              legal requirement that such communications be in writing.
            </p>

            <p>
              <strong>COPYRIGHT </strong>
            </p>
            <p>
              All content included on the PlantWatch Platform, such as text,
              graphics, logos, button icons, images, audio clips, digital
              downloads, data compilations, and software, is the property of
              TCPL or its content suppliers and protected by international
              copyright laPlantWatch. The compilation of all content on the
              PlantWatch Platform is the exclusive property of TCPL, with
              copyright authorship for this collection by TCPL, and protected by
              international copyright laPlantWatch.
            </p>
            <p>
              <strong>TRADE MARKS</strong>
            </p>
            <p>
              TCPL’s trademarks including but not limited to the PlantWatch
              Platform may not be used in connection with any product or service
              that is not TCPL’s, in any manner that is likely to cause
              confusion among customers, or in any manner that disparages or
              discredits TCPL. All other trademarks not owned by TCPL or its
              subsidiaries that appear on the PlantWatch Platform are the
              property of their respective owners, who may or may not be
              affiliated with, connected to, or sponsored by TCPL or its
              subsidiaries.
            </p>
            <p>
              <strong>ACCEPTABLE USE POLICY</strong>
            </p>
            <p>
              TCPL has adopted the following Acceptable Use Policy in order to
              assure that PlantWatch Platform is used in a lawful and
              appropriate manner. While TCPL does not ordinarily monitor the
              content of its users, it reserves the right to investigate reports
              of misuse of its service and to protect its property and assets.
              The following conduct is prohibited on the service:
            </p>
            <ul>
              <li>sending harassing, abusive, or threatening messages;</li>
              <li>sending obscene or pornographic messages or images;</li>
              <li>sending defamatory or libelous messages;</li>
              <li>
                sending viruses or other harmful, disruptive, or destructive
                files;
              </li>
              <li>attempting to steal passwords or credit card information;</li>
              <li>
                sending messages in furtherance of unlawful, criminal, or
                fraudulent activity; or
              </li>
              <li>
                Attempting to conceal or misrepresent the identity of the
                sender.
              </li>
            </ul>
            <p></p>
            <p>
              Violations of the TCPL’s Acceptable Use Policy will not be
              tolerated and may result in the sender being blocked from the
              PlantWatch Platform.
            </p>
            <p>
              <strong>USING YOUR OWN CONTENT, PHOTOS, OR IMAGES</strong>
            </p>
            <p>
              TCPL may allow you to upload your own photos or other materials.
              If you do so, you are subject to the conditions outlined in these
              Terms. When you upload photos or images to the PlantWatch Platform
              you are indicating that you own the photo or image or have full
              rights to its use. You are also indicating that the photos or
              images you upload do not depict any obscene, pornographic, or
              illegal materials.
            </p>
            <p>
              When you upload material on the PlantWatch Platform and use it,
              your material will be used for the transmission and as per our
              requirements in terms with our Privacy Policy; however, we may
              also use such material in the course of performing testing,
              training or archiving of our and our affiliates' systems and
              hereby expressly reserve the right to do so.
            </p>
            <p>
              <strong>SPAM</strong>
            </p>
            <p>
              The use of automated scripting-type programs that automate the
              process of sending or viewing any of the Materials is strictly
              prohibited. TCPL reserves the right to limit, in its sole
              discretion and without prior notice to you, the number of messages
              that you may send using the PlantWatch Platform.
            </p>
            <p>
              <strong>INDEMNIFICATION</strong>
            </p>
            <p>
              You agree to defend, indemnify and hold harmless TCPL, its
              affiliates, and their respective officers, directors, employees
              and agents, from and against any and all claims, damages,
              obligations, losses, liabilities, costs and expenses (including
              but not limited to attorney's fees) arising from:
            </p>
            <ul>
              <p>(i) your use of the PlantWatch Platform,</p>
              <p>(ii) your violation of these Terms &amp; Conditions,</p>
              <p>
                (iii) your violation of any law for the time being in force,
              </p>
              <p>
                (iv) your violation of the terms which apply to your User
                Submission,
              </p>
              <p>
                (v) your violation of any third party right, including without
                limitation any copyright, intellectual property, property,
                publicity or privacy right; or
              </p>
              <p>
                (vi) Any claim that one of your User Submissions caused damage
                to a third party.
              </p>
              <p>
                (vii) This defence and indemnification obligation will survive
                these Terms of Use and your use of the Website.
              </p>
            </ul>
            <p></p>
            <p>
              You must cooperate as fully as reasonably required in defense of
              any such claim. TCPL reserves the right, at its own expense, to
              assume the exclusive defense and control of any matter subject to
              indemnification by you.
            </p>

            <p>
              <strong>ABILITY TO ACCEPT TERMS OF USE</strong>{" "}
            </p>

            <p>
              You affirm that you are either more than 18 years of age to enter
              into these Terms of Use, and to comply with these Terms of Use.
            </p>

            <p>
              <strong>ASSIGNMENT </strong>
            </p>
            <p>
              These Terms of Use, and any rights and licenses granted hereunder,
              may not be transferred or assigned by you, but may be assigned by
              TCPL without restriction or requirement of a notice.
            </p>

            <p>
              <strong>DISPUTES</strong>
            </p>
            <p>
              The relationship between you and TCPL shall be governed by the
              laPlantWatch of the Republic of India without regard to any
              conflict of law provisions. You and TCPL agree to submit to the
              personal and exclusive jurisdiction of the courts located at
              Delhi, India.
            </p>

            <p>
              <strong>PRIVACY POLICY </strong>
            </p>
            <p>
              The terms of our privacy policy can be found at{" "}
              <a classNameName="termAndCondition" href="">
                Privacy Policy
              </a>
              . We reserve the right to make changes to the PlantWatch Platform,
              policies, and these Terms &amp; Conditions at any time. If any of
              these terms &amp; conditions are deemed invalid, void, or for any
              reason by a court of competent jurisdiction, such term or
              condition shall be deemed severable and shall not affect the
              validity and enforceability of the remaining terms &amp;
              conditions.
            </p>

            <p>
              <strong>QUESTIONS</strong>
            </p>
            <p style={{ paddingBottom: "4rem" }}>
              Questions regarding our Terms &amp; Conditions, Privacy Policy, or
              other policy related material can be directed to our support team
              at:{" "}
              <a>
                <em>imsnextapp@teamcomputers.com</em>
              </a>
            </p>
          </div>
        </div>

        <PublicFooter />
      </Box>
    </MDBox>
  );
};

export default TermsConditions;
